import { ROUTE_PATH } from "@/common/constants/routing";
import { AppPermission, ChatDto, ChatReferenceDto } from "@/core/api/generated/v1";

import {
  BaseEntityLink,
  BaseEntityLinkInheritableProps,
} from "../components/EntityLink/BaseEntityLink";
import ChatInline, { ChatInlineProps } from "./ChatInline";

interface Props extends BaseEntityLinkInheritableProps {
  entity: ChatDto | ChatReferenceDto | null | undefined;
  entityId?: string | null;
  inlineProps?: Partial<ChatInlineProps>;
}

export default function ChatLink({ entity, entityId, inlineProps, ...otherProps }: Props) {
  if (!entity && !entityId) {
    return null;
  }

  return (
    <BaseEntityLink
      entity={entity}
      entityId={entityId}
      permissions={[AppPermission.ChatRead]}
      to={ROUTE_PATH.CHAT_VIEW(entity?.id || entityId || "")}
      content={
        <ChatInline entity={entity} entityId={entityId} {...inlineProps} withTooltip={false} />
      }
      {...otherProps}
    />
  );
}
